import type { IPageableRequest, IPageableList } from "types";
import type { IProject, IProjectSummary } from "features/projects/types";

export type IWorkspaceId = number;
export type IProjectsLanguagesId = number;
export type IFileId = number;

export enum ItemsSorting {
  // noSorting = undefined,
  showAlphabeticallyByOriginal = 1,
  showAlphabeticallyByTranslation = 2,
  showGroupIdSorted = 3,
  showSorted = 4,
}

export interface IWorkspaceSummary {
  id: IWorkspaceId;
  name: string;
}

export type IWorkspace = IWorkspaceSummary & {
  completenessPercents: number;
  phrasesCount: number;
  approvedPhrasesCount: number;
  projects: IProject[];
};
export type WorkspacesResponse = IWorkspace;

// Files
export type IFilesPageableRequest = IPageableRequest & {
  projectLanguageId: IFileId;
};

export interface IFileResponse {
  approvedPhrasesCount: number;
  completenessPercents: number;
  id: number;
  name: string;
  phrasesCount: number;
}

export type IFilesResponse = IPageableList<IFileResponse> & {
  workspace: IWorkspaceSummary;
  project: IProjectSummary;
};

// Translation Items
export interface ITranslationLog {
  id: number;
  text: string;
  originalText: string;
  userEmail: string;
  logDate: string;
}

export interface ITranslationItem {
  id: number;
  groupName: string;
  idInFile: string;
  text: string;
  isApproved: boolean;
  enabledToTranslate: boolean;
  isValid: boolean;
}

export interface ITranslationItemResponse {
  original: ITranslationItem;
  translation: ITranslationItem;
  tags: string[];
  logs: ITranslationLog[];
}

export type IEditorFetchParams = IPageableRequest & {
  fileId: IFileId;
  itemsSort?: ItemsSorting;
  searchIdInFile: string;
  searchOriginal: string;
  searchTranslation: string;
  searchGroup: string;
  showInvalidOnly: boolean;
  searchExact: boolean;
  searchGroupFullMatch?: boolean;
  searchWholeProject?: boolean;
};

export type ITranslationItemsResponse = IPageableList<ITranslationItemResponse> & {
  translationLanguageIsoCode: string;
  originalLanguageIsoCode: string;
  validationTemplateId: number;
};

export interface ISimilarTranslationItemsFetchParams {
  fileId: string;
  searchOriginal: string;
}

export interface ISimilarTranslationItem {
  fileName: string;
  groupName: string;
  idInFile: string;
  text: string;
}

export type ISimilarTranslationItems = ISimilarTranslationItem[];
